import { PublicRoute } from "@/components/route-guard";

/**
 * Wrapper component for auth pages
 * Ensures authenticated users can't access signin/signup pages
 */
export function AuthPageWrapper({ children }: { children: React.ReactNode }) {
  return <PublicRoute>{children}</PublicRoute>;
}
